import {Toolbar} from '@devexpress/dx-react-grid-material-ui';
import {styled} from '@mui/material/styles';

const StyledOptixToolbar = styled(Toolbar.Root)(({theme}) => ({
  borderBottom: 'none !important',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'stretch',
  padding: '8px 8px 16px !important',
  gap: 16,
  minHeight: '0 !important',
  [theme.breakpoints.up('lg')]: {
    flexDirection: 'row-reverse',
    flexWrap: 'wrap',
    alignItems: 'center',
    justifyContent: 'flex-start',
    padding: '0 0 16px !important',
  },
}));

export function OptixTableToolbarRoot({
  children,
  ...props
}: Toolbar.RootProps): JSX.Element {
  return <StyledOptixToolbar {...props}>{children}</StyledOptixToolbar>;
}
